import { GameStateWithTable } from './GameStateWithTable';
import { TriangularCheckerBoard } from './TriangularCheckerBoard';
export class TriangularGameState extends GameStateWithTable {
    static getEmptyNeighbors(board, coord, empty) {
        const neighbors = [];
        for (const neighbor of TriangularCheckerBoard.getNeighbors(coord)) {
            if (neighbor.isInRange(board[0].length, board.length) &&
                (board[neighbor.y][neighbor.x] === empty)) {
                neighbors.push(neighbor);
            }
        }
        return neighbors;
    }
    getEmptyNeighbors(coord, empty) {
        return TriangularGameState.getEmptyNeighbors(this.board, coord, empty);
    }
}
export class FourStatePieceTriangularGameState extends TriangularGameState {
    hasPieceBelongingTo(coord, player) {
        const optional = this.getOptionalPieceAt(coord);
        if (optional.isPresent()) {
            return optional.get().is(player);
        }
        else {
            return false;
        }
    }
}
